export enum ESuggestedProductViewId {
  internalPage = 1,
  shoppingCart = 2,
  homepage = 3,
  fixedBanner = 4,
}
export enum ESuggestedProductType {
  I = 'I',
  P = 'P',
  S = 'S',
}
